import { ENDPOINT_ATTACHMENT } from '../config'
import type { AxiosResponse } from 'axios'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export interface ConfirmUploadResponse {
  id: string
  txid: number
}

/**
 * Confirm that a file has been successfully uploaded to R2
 */
const confirmUpload = async (
  workspaceId: string,
  attachmentId: string,
): Promise<ConfirmUploadResponse> => {
  const endpoint = `${ENDPOINT_ATTACHMENT(workspaceId, attachmentId)}/confirm`

  const response: AxiosResponse<ConfirmUploadResponse> =
    await AuthAxios.post(endpoint)

  return response.data
}

export default confirmUpload
